'use client';

import { Link } from '@/components/shared/Link';
import { ArrowRight } from 'lucide-react';
import { RichText } from '@/components/shared/RichText';

interface ServiceCardProps {
  title: string;
  description: string;
  href: string;
  image?: string;
  category?: string;
}

export function ServiceCard({ title, description, href, image, category }: ServiceCardProps) {
  return (
    <Link
      href={href}
      className="group relative block bg-navy p-6 md:p-[35px_40px] hover:bg-navy/90 transition-all duration-500 rounded-2xl shadow-sm hover:shadow-xl overflow-hidden min-h-[220px] md:min-h-[260px] flex items-center"
    >
      {/* Background Image with Overlay */}
      {image && (
        <>
          <div 
            className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-110"
            style={{ backgroundImage: `url(${image})` }}
          />
          <div className="absolute inset-0 bg-navy/80 group-hover:bg-navy/70 transition-colors duration-500" />
        </>
      )}

      <div className="relative z-10 flex items-start gap-4 md:gap-[3rem] w-full">
        <div className="flex-1">
          <h4
            className="text-[20px] md:text-[26px] font-bold text-white mb-4 leading-tight font-heading tracking-tight"
          >
            {title}
          </h4>
          <RichText
            html={description || ''}
            className="text-[13px] md:text-[15px] text-white/80 leading-relaxed font-sans max-w-[90%] font-light [&_p]:mb-2 [&_a]:text-white"
          />
        </div>
        <div className="flex items-center justify-center shrink-0 mt-1">
          <span className="flex h-12 w-12 items-center justify-center rounded-full border border-white/20 text-white bg-white/5 group-hover:bg-primary group-hover:border-primary group-hover:text-white transition-all duration-500 backdrop-blur-sm">
            <ArrowRight className="h-5 w-5" />
          </span>
        </div>
      </div>
    </Link>
  );
}
